:host {
  font-family: var(--ls-font-family);
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

:host > div {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.loading,
.error {
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
  font-family: var(--ls-font-family);
  color: var(--ls-font-primary-color);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  background-color: white;
}

.disconnected svg {
  display: none;
}

.disconnected::after {
  content: "Disconnected";
  position: absolute;
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  height: 100%;
  font-size: 2.5rem;
  color: #71717a;
  text-transform: uppercase;
  top: 0;
  text-align: center;
  border: 1px solid #71717a;
  background-color: rgba(255, 255, 255, 1);
}

.chart {
  width: 100%;
  max-width: 100%;
  height: auto;
  overflow: hidden;
  display: block;
}

.sensors-labels rect {
  fill: white;
}

.sensors-labels text {
  fill: var(--ls-font-primary-color);
  font-size: var(--ls-text-xs);
}

.swim-lanes text {
  fill: var(--ls-font-primary-color);
}

.sensor-value {
  alignment-baseline: central;
  dominant-baseline: central;
}

.swimlanes image {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  shape-rendering: crispEdges;
  transform: translateZ(0);
  will-change: transform;
}
